import React, { useState, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

const Contact = ({ isOpen, toggle, lang }) => {
  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} className="contact">
        <ModalHeader className="pb-2" toggle={toggle}>{lang.contact.title}</ModalHeader>
        <ModalBody>
          <div className="row pt-2 contact">
            <div className="col-md-12 text">{lang.contact.description}</div>
            <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
              <div className="border">
                <ul>
                  <i className="fas fa-globe-asia icon"></i>
                  <br />
                  {/* <li className="bold">{lang.footer.worldWideAssistance} </li>
                      <li>+603 7628 3860 / +603 7841 5770</li> */}
                  <li className="bold mt-3">{lang.footer.breakDownForPrivateCar} </li>
                  <li><a href="tel:1800188033">1800 18 8033</a></li>
                  <li className="bold mt-3">{lang.footer.breakDownForMotorcycle} </li>
                  <li><a href="tel:1300882323">1300 88 2323</a></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
              <div className="border">
                <ul>
                  <i className="fas fa-headphones-alt icon"></i>
                  <br />
                  <br />
                  <li className="bold">{lang.header.cs}</li>
                  <li>{lang.footer.time}</li>
                  <li><a href="tel:1800889933">1 800 889 933</a>{' (' + lang.footer.inMalaysia + ')'}</li>
                  <li><a href="tel:+60321707300">+603 2170 7300</a>{' (' + lang.footer.oversea + ')'}</li>
                  <li>
                    <a href={`mailto:${lang.header.email}`}>{lang.header.email}</a>
                  </li>
                  <br />
                  <li className="bold">{lang.header.cs2}</li>
                  <li><a href="tel:+60362047788">+603 6204 7788</a>{" (" + lang.header.twentyfourhours + ")"}</li>
                  <li>
                    <a href={`mailto:${lang.header.email2}`}>{lang.header.email2}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
              <div className="border">
                <ul>
                  <i className="fas fa-map-marker-alt icon"></i>
                  <br />
                  <br />
                  <li className="bold">
                    Berjaya Sompo Insurance Berhad
                    <br />
                    {lang.contact.registrationNo}: 198001008821 (62605-U)
                  </li>
                  <li>Level 36, Menara Bangkok Bank, 105, Jalan Ampang, 50450 Kuala Lumpur</li>
                </ul>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default Contact
